import { api } from '@/api/client';

export function getProjectNotesQueryOptions(projectId: string) {
  return {
    queryKey: ['projectNotes', projectId] as const,
    queryFn: () => api.projectNotes.list(projectId),
    staleTime: 60_000,
  };
}
